/**
 * Langue choisie dans le formulaire d'inscription. La détection i18n de la
 * console est « navigateur uniquement, sans cache » (main.tsx) : ce choix ne
 * survivrait pas au rechargement complet de l'aller-retour Stripe — on le
 * persiste donc explicitement, et la page success le restaure. Le relais est
 * ensuite pris par client.language (HomeContent), même valeur.
 */

const KEY = 'signupLang';

export function saveSignupLang(lang: string) {
    try {
        localStorage.setItem(KEY, lang);
    } catch {
        /* Safari privé : la page success restera en langue navigateur. */
    }
}

export function readSignupLang(): string | null {
    try {
        return localStorage.getItem(KEY);
    } catch {
        return null;
    }
}
